'use client';

import { c as _c } from "react/compiler-runtime";
import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props';
import { TopNavV6MobileBar } from './TopNavV6MobileBar';
import { TopNavV6MobileSlidingPanel } from './TopNavV6MobileSlidingPanel';
export const TopNavV6Mobile = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <nav aria-label="Main" className="relative z-50 overflow-x-clip lg:hidden"><div className="w-full bg-bodi-black-text font-medium text-bodi-white"><TopNavV6MobileBar {...props} /></div><TopNavV6MobileSlidingPanel {...props} /></nav>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};